<template lang="pug">
//- 新生學園
.group-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .group-title 新生學園

  .row.group-content
    .group-content-right.padding-none
      .filter-com
        .language 
          //- 語言別
          .language-filter
            .filter-item.click-cursor(
              v-for="lang in course_langs",
              v-bind:class="[language_filter === lang.id ? 'bg-blue-1' : 'bg-gray-1']",
              @click="setCourseLange(lang.id)"
            ) {{ lang.name }}
            .clearfix
    .clearfix
  .newpark-list.newpark-list-default
    //- 課程區塊
    .item-content-box(
      v-for="theme in seriesList",
      @click="clickCourseIn(theme.id, theme)"
    )
      .item-content(v-bind:class="confirmColor(false, theme.langs_type)")
        .item-up
          .item-title {{ theme.title }}
          .item-title {{ theme.title_lang }}

        .item-down
          //- 課程資訊
          .coruse-length {{ theme.teacher.name }}
            span {{ theme.directions }}
    .clearfix

  .more-btn.click-cursor(v-if="page < perMaxPage", @click="getNextSeries()") 載入更多
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import DateCom from '@/components/date'
import FilterCom from '@/components/filter'
import GroupTimeTableArea from '@/components/group/group-timetable-area'
export default {
  coures_teacher: {
    name: 'Index',
  },
  components: {
    ContentTop,
    DateCom,
    FilterCom,
    GroupTimeTableArea
  },
  data () {
    return {
      //- 日期開關
      date_turn: false,
      //- 語言篩選狀態
      language_filter: "all",
      course_langs: [
        { id: "all", name: "全部" },
        { id: "EN", name: "美語" },
        { id: "JP", name: "日語" },
        { id: "KO", name: "韓語" },
      ],
      //- 主題清單
      seriesList: [],
      //- 控制下頁按鈕是否出現
      //- 如果達到最大頁數則應該要被開啟 (不出現按鈕)
      isMaxPage: false,
      perMaxPage: 1,
    };
  },
  async created () {
    // 關閉載入中畫面
    this.$root.closeLoading()
    // 初始化頁數
    this.page = 1
    // 獲取新生學園列表
    await this.getSeries()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 設定課程語言
    async setCourseLange (_langID) {
      this.language_filter = _langID
      // 初始化頁數
      this.page = 1
      // 獲取新生學園列表
      await this.getSeries()
    },
    clickCourseIn (_seriesId, _seriesDetails) {
      this.$root.enterNewParkIn(_seriesId, _seriesDetails)
    },
    // 獲取下一頁資料
    async getNextSeries () {
      if (this.page >= this.perMaxPage) {
        return
      }

      // 進入下一頁
      this.page += 1
      // 請求獲取資料
      await this.getSeries()
    },
    // 獲取新生學園列表
    async getSeries () {
      // 初始化新生學園列表
      this.seriesList = (this.page === 1) ? [] : this.seriesList
      // 獲取新生學園列表資料
      await this.$root.apis.getSeries(this.page, this.language_filter, this.processGetSeriesSuccess, this.processStatusError)
    },
    async processGetSeriesSuccess (_response) {
      var vm = this
      this.perMaxPage = _response.body.preMax
      _response.body.data.forEach(function (_series) {
        vm.seriesList.push(_series)
      })
    },
    async processStatusError (_error) {
      console.log(_error)
    },
    // 確認語系對應的顏色
    confirmColor (_isExpired = false, _courseLang = '') {
      // 當課程已經結束
      if (_isExpired) {
        return 'bg-gray-1'
      }

      // 根據語言判斷顏色
      let color = ''
      switch (_courseLang) {
        case 'en':
          color = 'bg-purple'
          break

        case 'ja':
          color = 'bg-orange'
          break

        default:
          color = 'bg-green'
          break
      }

      return color
    },
  }
}
</script>
<style lang="sass">
.filter-com
  width: 100%
  margin: 3rem 0 0 0
  overflow: hidden
  .language
    margin-right: 2rem
  .language-filter
  .filter-sm-title
    margin: .55rem 0 .1rem 0
  .class-box
    padding-left: .2rem
    width: 100%
    overflow: auto
    .class-filter
      width: 40rem

  .filter-item
    float: left
    height: 2.6rem
    line-height: 2.6rem
    margin-right: .5rem
    border-radius: 5px
    padding: 0 1.3rem
    font-size: .7rem
    font-weight: 500
    text-align: center
    &:active
      opacity: .6
  .bg-blue-1
    background: #2e50ff
    color: #fff
    font-size: .8rem
  .bg-gray-1
    background: #f3f3f3
    color: #91a1c1
.newpark-list
  width: calc(100% - 8rem)
  margin: 2rem 4rem
  display: grid
  gap: 10px
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr))
  .bg-purple
    background: #cceafb
  .bg-green
    background: #e7bbfc
  .bg-orange
    background: #fadbe8

  .item-content-box
    width: 100%

    .item-content
      border-radius: 10px
      width: 320px
      padding: 1rem
      position: relative
      &:active
        opacity: .7

    .item-down
      margin-top: 2vmin
      position: relative
      text-align: left
      padding: 0 0vmin 0 0vmin
      width: 100%
      .teacher-box
        margin: 2vmin 0
        .teacher-img
          width: 14vmin
          height: 14vmin
          object-fit: cover
          border-radius: 50%
          float: left
          margin-right: 3vmin
        .teacher-name
          color: #191d35
          font-size: 4vmin
          font-weight: 500
          line-height: 7vmin
          margin: 3.5vmin 0
          float: left
          max-width: 22vmin
      .coruse-length
        color: #91a1c1
        font-size: .9rem
        font-weight: 500
        line-height: 1rem
        margin-top: 1rem
        span
          color: #91a1c1
          margin-left: .3rem
    .item-title
      color: #191d35
      font-size: .9rem
      font-weight: 500
      line-height: 20px
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      white-space: normal
      margin-top: 0.2rem
.more-btn
  margin: 0 auto 5rem auto
  width: fit-content
  height: 2.6rem
  line-height: 2.6rem
  border-radius: 5px
  padding: 0 1.3rem
  font-size: .7rem
  font-weight: 500
  text-align: center
  background: #2e50ff
  color: #fff
  font-size: .8rem
</style>
